import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";

export class OrganizationsOverviewCtrl implements IController {

  resources: any;


  public loading: boolean = false;
  public viewType: any = undefined;
  // public overviewConfig:any = {};
  public filterConfig: any = {};
  public organizationsMap: any = {};
  public sites: any = [];
  public from: any;
  public to: any;

  constructor(private $state, private dateRangeTimeFiltersService: DateRangeTimeFiltersService) {
  }

  $onInit() {
    this.viewType = 'table'; // table/list

    this.filterConfig = {
      customTemplates: this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates(),
      range: this.from && this.to ? {dateStart: this.from, dateEnd: this.to} : this.dateRangeTimeFiltersService.today(),
      queryString: undefined
      // selectedServiceAreaIds: ctrl.serviceAreaIds
    };

    _.forEach(this.resources, (resource) => {
      if (_.isUndefined(resource.parentId)) {
        this.organizationsMap[resource.id] = {
          id: resource.id,
          open: false, // index === 0
          name: resource.name,
          sites: []
        };
      } else {
        this.sites.push(resource);
      }
    });

    _.forEach(this.sites, (site) => {
      if (this.organizationsMap[site.parentId]) {
        this.organizationsMap[site.parentId].sites.push(site);
      }
    });
  }

  onToggleViewType(viewType) {
    this.viewType = viewType === 'table' ? 'list' : 'table';
  }

  onToggleOverview(organization) {
    organization.open = !organization.open;
  }

  onRangeChanged(range) {
    if (!_.isUndefined(range) &&
      (!_.isEqual(range.dateStart, this.filterConfig.range.dateStart) || !_.isEqual(range.dateEnd, this.filterConfig.range.dateEnd))) {
      this.filterConfig.range = range;
      this.$state.go('.', {from: range.dateStart, to: range.dateEnd}, {notify: false, reload: false})
    }
  }

}

angular
  .module('bringoz.admin.organizations')
  .component('organizationsOverview', {
    bindings: {
      resources: '<'
    },
    template: require('./organizations-overview.html').default,
    controller: OrganizationsOverviewCtrl
  });
